import { CommonConstants } from '@/config/constant';

export default function getComma(value) {
  if (!value) {
    return 0;
  }
  if (typeof value == 'string' && value.match(CommonConstants.SPECIAL_CHAR)) return value;
  return Number(value).toLocaleString('ja-JP');
}
